<template>
    <div class="apply-list">
        <div v-if="applyManager.data.ready">
            <div v-show=" step === 1 ">
                <step1/>
            </div>
            
            <div v-if="step === 2">
                <step-main/>
            </div>
            
            <div v-if="step === 3">
                <step3/>
            </div>
            
            <div v-if="step === 4">
                <step4/>
            </div>
            
            <div v-if="step === 5">
                <step5/>
            </div>
            
            <div v-if="step === 6">
                <step6/>
            </div>
            
            <div v-if="step === 7">
                <step7 />
            </div>
        </div>
    
    
    </div>
</template>

<script>
import Step1 from "./Step/Step1";
import StepMain from "./Step/StepMain";
import Step3 from "./Step/Step3";
import Step4 from "./Step/Step4";
import Step5 from "./Step/Step5";
import Step6 from "./Step/Step6";
import Step7 from "./Step/Step7";
import ecApply from "@/store/ec-apply";

export default {
    name: "Index",
    components: {Step7, Step6, Step5, Step4, Step3, StepMain, Step1},
    props: {
        customerType: String,
    },
    data() {
        return {
            applyManager: ecApply,
        }
    },
    mounted() {
        ecApply.init()
    },
    computed: {
        step() {
            return ecApply.data.step
        }
    },
    destroyed() {
        ecApply.destroy()
    }
}
</script>

<style lang="less" scoped>

.apply-list {
    max-width: 1000px;
}

</style>